import { useEffect } from "react";
import { useRoute } from "./useRoute";

export const INCLUDE_DELETED_RESOURCE_QUERY_KEY = "includeDeletedResource";

export function useIncludeDeletedQueryParam(req: { key: string; value: boolean }) {
  const { key, value } = req;
  const { query, replaceQuery } = useRoute();

  useEffect(() => {
    if (value) {
      replaceQuery({ [key]: String(value) }, true);
    } else {
      const newQuery = Object.keys(query).reduce((prev, curr) => {
        prev[curr] = String(query[curr]);
        return prev;
      }, {} as { [key: string]: string });

      delete newQuery[key];

      replaceQuery(newQuery, false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);
}
